import Vue from 'vue';
import http from '../utils/http';
import axios from 'axios';

export default {
    state: {
        promo: null,
        codes:[],
        institutes: [],
    },
    mutations: {
        loadCodes(state, payload) {
            state.codes = payload;
        },
        loadInstitutes(state, payload) {
            state.institutes = payload;
        },
        setPromo(state, payload) {
			state.promo = payload
		},
        addCode(state, payload) {
            //add to institute.codes
            const institute = state.institutes.find(inst => inst.id == payload.instituteId)
            if (institute) {
                let index = institute.codes?.length || 0;
                Vue.set(institute.codes, index, payload);
            }	
		},
        addInstitute(state, payload) {
			let index = state.institutes.length;
            Vue.set(state.institutes, index, payload); 
		},
        deleteInstitute(state, payload) {
            state.institutes =  state.institutes.filter(s => s.id !== payload)
        },
        deletePromo(state, payload) {
            const institute = state.institutes.find(inst => inst.id == payload.instituteId)
            institute.codes =  institute.codes.filter(s => s.id !== payload.id)
        },
    },
    actions: {
        async fetchCodes({commit}) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/promo`);
                console.log(result)
                if (result) {
                   const codes = await result.data 
                   commit('loadCodes', codes)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async fetchInstitutes({commit}) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/institute`);
                console.log(result)
                if (result) {
                   const institutes = await result.data 
                   commit('loadInstitutes', institutes)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async fetchPromo({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/promo/${ payload }`);
                if (result) {
                   const promo = await result.data 
                   commit('setPromo', promo)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async checkPromo({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await axios.get(`/promo/check/${ payload }`);
                if (result) {
                   const promo = await result.data 
                   commit('setPromo', promo)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async addCode({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            try {
                const result = await http.post(`/promo`, payload);
                
                if (result) {
                   const promo = await result.data; 
                   commit('addCode', promo);
                }                
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async printCode({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            try {
                const result = await http.post(`/print-pdf`, payload);
                if (result) {
                   //const promo = await result.data; 
                   console.log(result.data)
                }                
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async addInstitute({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            try {
                const result = await http.post(`/institute`, payload);
                if (result) {
                    const inst = await result.data; 
                    commit('addInstitute', inst);
                }              
                commit('setLoading', false);
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async deleteCode({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/promo/${payload.id}`);
                //console.log(result)
                commit('deletePromo', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteInstitute({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            
            try {
                await http.delete(`/institute/${payload}`);
                //console.log(result)
                commit('deleteInstitute', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
    },
    getters: {
        promo (state) {
            return state.promo;
        },
        codes(state) {
            return state.codes;
        },
        institutes(state) {
            return state.institutes;
        }
    }
}